// GENERATED FILE - DO NOT MODIFY
export enum ServiceCallLabourBillingCatalogCode {
    ServiceCallActivity = "CODEACTIVAS",
    ServiceCallCategory = "NOCATAS",
}

export let nameof = "ServiceCallLabourBillingCatalogCode";
